import { action } from 'easy-peasy';
import { ISetSosRequestAction } from '../types';

const setSosRequest: ISetSosRequestAction = action((state, payload) => {
  state.current = payload;
});

export default setSosRequest;
